import React from "react";
import { connect } from "react-redux";
import Spinner from "../../components/Spinner";
import ProfileItem from "./ProfileItem";
import { getProfiles } from "../../actions/profileActions";
import { Container, Grid } from "semantic-ui-react";
import { ProfileData } from "../../types/siteTypes";
import { profileListSelector } from "../../utils/selectors";

type Props = {
  profileList: { profiles: ProfileData[]; loading: boolean };
  getProfiles: () => void;
};

const Profiles: React.FC<Props> = ({
  profileList: { loading, profiles },
  getProfiles,
}) => {
  React.useEffect(() => {
    getProfiles();
  }, [getProfiles]);

  return (
    <Container>
      <Grid>
        <Grid.Row>
          {loading ? (
            <Spinner />
          ) : (
            profiles &&
            profiles.map((profile: any) => (
              <ProfileItem profile={profile} key={profile._id} />
            ))
          )}
        </Grid.Row>
      </Grid>
    </Container>
  );
};

const mapStateToProps = (state: any) => ({
  profileList: profileListSelector(state),
});
const mapDispatchToProps = (dispatch: any) => ({
  getProfiles: () => dispatch(getProfiles()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profiles);
